/**
 * License Expiry Banner Component
 * Displays warnings when license is expired or expiring soon
 */

import React from 'react';
import { LicenseService } from '../../../services/enterprise/license.service';

interface LicenseExpiryBannerProps {
    className?: string;
}

const LicenseExpiryBanner: React.FC<LicenseExpiryBannerProps> = ({ className = '' }) => {
    const licenseStatus = LicenseService.getLicenseStatus();

    // Don't render if license is valid and not expiring soon
    if (!LicenseService.shouldShowWarning()) {
        return null;
    }

    const alertClass = licenseStatus.isExpired ? 'alert-danger' : 'alert-warning';
    const iconClass = licenseStatus.isExpired ? 'bi-exclamation-triangle-fill' : 'bi-exclamation-triangle';
    const title = licenseStatus.isExpired ? 'License Expired' : 'License Expiring Soon';

    return (
        <div className={`alert ${alertClass} d-flex align-items-center ${className}`} role="alert">

            <div className="flex-grow-1">
                <i className={`bi ${iconClass} me-3`} style={{ fontSize: '1.2rem' }}></i>
                <h6 className="alert-heading mb-1">{title}</h6>
                <p className="mb-0">{licenseStatus.warningMessage}</p>
            </div>
        </div>
    );
};

export default LicenseExpiryBanner;